module.exports = __webpack_public_path__ + "static/media/book-pile.835130fb.png";